import React, { Component } from "react";

import history from "../../../history"
import Constants from "../../../Phi/Constants";

import moment from "moment";

import FormComponent from "../../../Components/FormComponent";
import Validator from "../../../Components/FormComponent/Validator";

import groupPictureMain from "./assets/group-picture-main.png";

import HSGModalComponent from "../../HSGModalComponent/HSGModalComponent";

import "./CovidDeclaration.css";

// Icons for Global Covid Cases
import iconCovidGlobalConfirmed from "./assets/icon-covid-global-confirmed.svg";
import iconCovidGlobalRecovered from "./assets/icon-covid-global-recovered.svg";
import iconCovidGlobalActive from "./assets/icon-covid-global-active.svg";
import iconCovidGlobalDeceased from "./assets/icon-covid-global-deceased.svg";
import iconLocation from "./assets/icon-location.svg"

const FORM_DATA_ERROR_MESSAGE_TEMPERATURE = "Body temperature should lie under 93-106 F";

const FORM_DATA = {
    key: "covid-declaration-form",
    metaData: [
        // {
        //     name: "temperature",
        //     type: "text",
        //     className: {
        //         fieldClassName: "hsg-covid-declaration-form-input hsg-covid-declaration-form-input-small",
        //         groupClassName: "hsg-covid-declaration-input-group col-xs-12",
        //         errorClassName: "hsg-covid-declaration-error padding-0",
        //         labelClassName: "hsg-covid-declaration-form-label",
        //     },
        //     label: "Body Temperature *",
        //     placeholder: "F",
        //     validation: [
        //         Validator.required,
        //         Validator.checkNumeric,
        //         Validator.maxValue(106, FORM_DATA_ERROR_MESSAGE_TEMPERATURE),
        //         Validator.minValue(93, FORM_DATA_ERROR_MESSAGE_TEMPERATURE),
        //     ],
        // },
        {
            name: "fever",
            type: "radio",
            className: {
                fieldClassName: "hsg-covid-declaration-form-radio",
                groupClassName: "hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-covid-declaration-error",
                labelClassName: "hsg-covid-declaration-form-label-radio",
            },
            options: [
                {
                    label: "Yes",
                    value: "True",
                    id: "fever-yes",
                },
                {
                    label: "No",
                    value: "False",
                    id: "fever-no",
                },
            ],
            label: "Fever (°F greater than 99) *",
            placeholder: "",
            validation: [Validator.required],
        },
        {
            name: "cough",
            type: "radio",
            className: {
                fieldClassName: "hsg-covid-declaration-form-radio",
                groupClassName: "hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-covid-declaration-error",
                labelClassName: "hsg-covid-declaration-form-label-radio",
            },
            options: [
                {
                    label: "Yes",
                    value: "True",
                    id: "cough-yes",
                },
                {
                    label: "No",
                    value: "False",
                    id: "cough-no",
                },
            ],
            label: "Dry Cough *",
            placeholder: "",
            validation: [Validator.required],
        },
        {
            name: "breathing",
            type: "radio",
            className: {
                fieldClassName: "hsg-covid-declaration-form-radio",
                groupClassName: "hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-covid-declaration-error",
                labelClassName: "hsg-covid-declaration-form-label-radio",
            },
            options: [
                {
                    label: "Yes",
                    value: "True",
                    id: "breathing-yes",
                },
                {
                    label: "No",
                    value: "False",
                    id: "breathing-no",
                },
            ],
            label: "Difficulty in Breathing *",
            placeholder: "",
            validation: [Validator.required],
        },
        {
            name: "throat",
            type: "radio",
            className: {
                fieldClassName: "hsg-covid-declaration-form-radio",
                groupClassName: "hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12",
                errorClassName: "hsg-covid-declaration-error",
                labelClassName: "hsg-covid-declaration-form-label-radio",
            },
            options: [
                {
                    label: "Yes",
                    value: "True",
                    id: "throat-yes",
                },
                {
                    label: "No",
                    value: "False",
                    id: "throat-no",
                },
            ],
            label: "Sore Throat *",
            placeholder: "",
            validation: [Validator.required],
        },
        // {
        //     name: "covidDeclarationFileUpload",
        //     type: "covidDeclarationFileUpload",
        // },
        {
            name: "covidDeclarationCertify",
            type: "covidDeclarationCertify",
        },
    ],
    submitButton: {
        text: "Submit",
        hide: false,
        className: {
            fieldClassName: "hsg-btn left hsg-covid-declaration-btn-modified",
            groupClassName: "hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12",
        },
    },
    closeButton: {
        hide: true,
        className: {
            fieldClassName: "hsg-btn right",
            groupClassName: "hsg-input-grp col-md-12 col-sm-12 col-xs-12",
        },
    },
};

const COVID_DECLARATION_GLOBAL_STATS = [
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Confirmed",
        key: "confirmed",
        icon: iconCovidGlobalConfirmed,
        iconBackground: {
            background: "rgba(255, 0, 0, 0.3)",
            borderRadius: 4,
        },
    },
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Active",
        key: "active",
        icon: iconCovidGlobalActive,
        iconBackground: {
            background: "rgba(0, 145, 255, 0.3)",
            borderRadius: 4,
        },
    },
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Recovered",
        key: "recovered",
        icon: iconCovidGlobalRecovered,
        iconBackground: {
            background: "rgba(0, 172, 90, 0.3)",
            borderRadius: 4,
        },
    },
    {
        className: "hsg-dashboard-covid-overall-numbers-width padding-right-0",
        label: "Deceased",
        key: "deceased",
        icon: iconCovidGlobalDeceased,
        iconBackground: {
            background: "rgba(82, 93, 125, 0.3)",
            borderRadius: 4,
        },
    },
];

const API_DATE_FORMAT = "yyyy-MM-DD";

const FORM_TYPE = {
    declaration: 0,
    submission: 1,
};

const TYPE_MAP_SUBMISSION = {
    NORMAL: 1,
    SUSPECTED: 2,
    RISK: 3,
};

const ROUTE_MAP = {
    MY_DECLARATION: "my-declaration"
}

const STRING_COVID_DECLARATION_HEADING = "COVID-19 SELF DECLARATION FORM";
const STRING_COVID_DECLARATION_IMAGE_LABEL = "Arogya Setu Screenshot *";
const STRING_COVID_DECLARATION_IMAGE_UPLOAD_BUTTON = "UPLOAD";
const STRING_COVID_DECLARATION_IMAGE_NO_FILE_SELECT = "No file selected";
const STRING_COVID_DECLARATION_CERTIFY =
    "I certify that the information I have provided is true and complete to the best of my knowledge. Iam aware that this self-declaration statement is subject to review and verification.";

const STRING_COVID_DECLARATION_MODAL_MESSAGE =
    "Thank you !! This data will be retained confidentially by the school after submission. The health and wellbeing of our community is our first priority therefore the School reserves the right to deny entry to the campus.";

const STRING_COVID_DECLARATION_MODAL_STATUS_DATE_TODAY = moment().local().format('MMM Do')
const STRING_COVID_DECLARATION_MODAL_STATUS_NORMAL = `As per your submission on ${STRING_COVID_DECLARATION_MODAL_STATUS_DATE_TODAY} you are at no risk! You are safe.`;
const STRING_COVID_DECLARATION_MODAL_STATUS_SUSPECTED = `As per your submission on ${STRING_COVID_DECLARATION_MODAL_STATUS_DATE_TODAY} you are at risk!`;
const STRING_COVID_DECLARATION_MODAL_STATUS_RISK = `As per your submission on ${STRING_COVID_DECLARATION_MODAL_STATUS_DATE_TODAY} you are at high risk!`;

const STRING_COVID_DECLARATION_RESPONSE_HEAD = "Thank you!";
const STRING_COVID_DECLARATION_RESPONSE_CONTENT =
    "Note : Your health and safety is our priority. This data will be retained confidentially by the institution after submission. The institution reserves the right to deny entry to the campus based on your submission.";
const STRING_COVID_DECLARATION_RESPONSE_ADVISE_NORMAL = "We are looking forward to seeing you in campus today!";
const STRING_COVID_DECLARATION_RESPONSE_ADVISE_RISK = "It is requested that you should stay home and rest.";

const STRING_COVID_DECLARATION_BUTTON_OK = "OK";
const STRING_COVID_DECLARATION_BUTTON_VIEW_RESPONSE = "View Response";
const STRING_COVID_DECLARATION_BUTTON_ANOTHER_RESPONSE = "Submit another response";

const STRING_COVID_DECLARATION_MODAL_MESSAGE_ERROR =
    "Thank you !! But there seems to be an error. Please connect with HSG HO.";

const IMAGE_UPLOAD_CATEGORY = "codiv-declaration-supporting-document";
const IMAGE_UPLOAD_GROUP = "codiv-declaration-supporting-document";

const TYPE_SUBMISSION_HIGH_RISK = "highRisk";
const TYPE_SUBMISSION_SUSPECTED = "suspected";
const TYPE_SUBMISSION_NORMAL = "normal";

const TYPE_UPLOAD_SCREENSHOT = ["image/jpeg", "image/jpg", "image/png", "image/svg", "image/gif", "image/bmp"];
const TYPE_UPLOAD_SCREENSHOT_ALLOWED = ".jpeg, .jpg, .png, .svg, .gif, .bmp";

const ERROR_EMPTY_FIELD = "*field is required";
const ERROR_INCORRECT_IMAGE_TYPE = "*only accept jpg/png/jpeg/bmp/gif/svg format";

const STRING_GLOBAL_STATS_VIEW_MORE = "View More";
const URL_COVID_DASHBOARD_REF = "https://www.covid19india.org/";

class CovidDeclaration extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentActiveForm: FORM_TYPE.declaration,
            currentUserLatestDeclarationStatus: null,

            formSubmission: false,
            isFirstDeclaration: false,

            defaultDeclarationListFilters: {
                inUserId: null,
                inOrganizationId: null,
                inLimit: 1,
                inOffset: 0,
                // startDate: moment().utc().format(API_DATE_FORMAT),
                // endDate: moment().utc().format(API_DATE_FORMAT),
            },
        };
    }

    componentDidMount() {
        let { selectedUserId, selectedOrganizationId } = this.props;

        if (selectedUserId) {
            this.getCovidDeclarationList(selectedUserId, selectedOrganizationId);
            this.props.fetchOrganization(selectedOrganizationId)
        }
    }

    componentWillReceiveProps(newProps) {
        let formResponse = this.props.responseCovidDeclarationForm;
        let newFormResponse = newProps.responseCovidDeclarationForm;

        if (
            newFormResponse.showResponseModal &&
            formResponse.showResponseModal !== newFormResponse.showResponseModal &&
            this.state.formSubmission &&
            newProps.selectedUserId
        ) {
            // this.getCovidDeclarationList(newProps.selectedUserId, newProps.selectedOrganizationId);
            this.setState({ formSubmission: false });
        } else if (!!!newFormResponse.showResponseModal && this.state.formSubmission) {
            this.setState({ formSubmission: false });
        }

        if (newProps.selectedUserId && newProps.selectedUserId !== this.props.selectedUserId) {
            this.getCovidDeclarationList(newProps.selectedUserId, newProps.selectedOrganizationId);
            this.props.fetchOrganization(newProps.selectedOrganizationId)
        }

        if (
            newProps.responseCovidDeclarationList &&
            newProps.responseCovidDeclarationList.declarations !== this.props.responseCovidDeclarationList.declarations
        ) {
            let { declarations } = newProps.responseCovidDeclarationList;

            let isTodays =
                declarations && declarations.length ? moment(declarations[0].declarationDate).format("YYYYMMDD") === moment().utc().format("YYYYMMDD") : false

            this.setState({
                currentActiveForm: isTodays ? FORM_TYPE.submission : FORM_TYPE.declaration,
                currentUserLatestDeclarationStatus: isTodays ? declarations[0].resultStatus : null,
                isFirstDeclaration: declarations && declarations.length ? false : true
            });
        }

        if (this.props.organization.stateName !== newProps.organization.stateName || this.props.organization.cityName !== newProps.organization.cityName) {
            this.props.getCovidGlobalDashboard(newProps.organization.stateName, newProps.organization.cityName);
        }
    }

    getCovidDeclarationList = (userId, organizationId) => {
        this.setState({
            defaultDeclarationListFilters: {
                ...this.state.defaultDeclarationListFilters,
                inUserId: userId,
                // inOrganizationId: organizationId,
            },
        });
        this.props.getCovidDeclarationList({
            ...this.state.defaultDeclarationListFilters,
            inUserId: userId,
            // inOrganizationId: organizationId,
        });
    };

    covidDeclarationFileUpload = () => (
        <div className="hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12">
            <div className="hsg-covid-declaration-form-label">{STRING_COVID_DECLARATION_IMAGE_LABEL}</div>
            <div>
                {/* <button className="hsg-btn hsg-covid-declaration-btn-modified" onClick={()=>this.onFileUpload}>UPLOAD</button> */}
                {/* <input type='file' className="hsg-btn hsg-covid-declaration-btn-modified" onClick={()=>this.onFileUpload} name="UPLOAD"/> */}

                <label className="hsg-btn hsg-covid-declaration-btn-modified">
                    <input
                        type="file"
                        onChange={(file) => this.onFileUpload(file)}
                        accept={TYPE_UPLOAD_SCREENSHOT_ALLOWED}
                    />
                    {STRING_COVID_DECLARATION_IMAGE_UPLOAD_BUTTON}
                </label>
                <span className="hsg-covid-declaration-form-label" style={{ paddingLeft: 10 }}>
                    {this.state.imageObjName || STRING_COVID_DECLARATION_IMAGE_NO_FILE_SELECT}
                </span>
                <div>
                    {this.state.errorNoImageUploaded ? (
                        <span className="hsg-covid-declaration-error padding-0">{this.state.errorNoImageUploaded}</span>
                    ) : null}
                </div>
            </div>
        </div>
    );

    onFileUpload = (files) => {
        let file = files.target.files[0] || {};
        let type = file.type;

        if (TYPE_UPLOAD_SCREENSHOT.includes(type)) {
            this.setState({
                imageObj: file,
                imageObjName: file.name,
                errorNoImageUploaded: false,
            });
        } else {
            this.setState({
                imageObj: null,
                imageObjName: null,
                errorNoImageUploaded: ERROR_INCORRECT_IMAGE_TYPE,
            });
        }
    };

    covidDeclarationCertify = () => (
        <div className="hsg-covid-declaration-input-group col-md-12 col-sm-12 col-xs-12">
            <div className="hsg-covid-declaration-checkbox-main">
                <div className="hsg-covid-declaration-checkbox">
                    <input
                        type="checkbox"
                        value={this.state.covidDeclarationCertify}
                        id="hsg-covid-declaration-certify-checkbox"
                        name="hsg-covid-declaration-checkbox"
                        onChange={() => {
                            this.setState({
                                covidDeclarationCertify: !!!this.state.covidDeclarationCertify,
                                errorNoCertification: false,
                            });
                        }}
                    />
                    <label htmlFor="hsg-covid-declaration-certify-checkbox"></label>
                </div>
                <span className="hsg-covid-declaration-form-label">{STRING_COVID_DECLARATION_CERTIFY}</span>
                <div>
                    {this.state.errorNoCertification ? (
                        <span className="hsg-covid-declaration-error padding-0">{ERROR_EMPTY_FIELD}</span>
                    ) : null}
                </div>
            </div>
        </div>
    );

    checkSubmissionStatus = (data) => {
        let temperature = parseFloat(data.temperature);
        let cough = data.cough === "True";
        let throat = data.throat === "True";
        let breathing = data.breathing === "True";
        if (temperature > 99 && cough && throat && breathing) {
            this.setState({ currentFormSubmission: TYPE_SUBMISSION_HIGH_RISK });
        } else if (temperature > 99 || cough || throat || breathing) {
            this.setState({ currentFormSubmission: TYPE_SUBMISSION_SUSPECTED });
        } else {
            this.setState({ currentFormSubmission: TYPE_SUBMISSION_NORMAL });
        }
    };

    handleSubmit = (data) => {
        const { selectedUserId, selectedOrganizationId, selectedUserRoleId } = this.props;
        // let child = this.props.childList[this.props.selectedChild];
        let error = false;
        // if (!!!this.state.imageObjName) {
        //     this.setState({ errorNoImageUploaded: ERROR_EMPTY_FIELD });
        //     error = true;
        // }

        if (!!!this.state.covidDeclarationCertify) {
            this.setState({ errorNoCertification: true });
            error = true;
        }

        // if (child && !error) {
        if (selectedUserId && selectedUserRoleId && !error) {
            // this.checkSubmissionStatus(data)

            this.props.postCovidDeclarationForm(
                selectedUserId,
                selectedOrganizationId,
                { ...data, certified: this.state.covidDeclarationCertify },
                this.state.imageObj,
                selectedUserRoleId
            );

            if ( this.state.isFirstDeclaration ){
                let template
                if ( selectedUserRoleId === Constants.roleIdMap.PARENT && selectedOrganizationId ===  Constants.covidDeclarationDefaultOrganization ) {
                    template = Constants.communicationMap.EMAILS.FIRST_COVID_SUBMISSION['member']
                }else {
                    template = Constants.communicationMap.EMAILS.FIRST_COVID_SUBMISSION[selectedUserRoleId]
                }

                const userName = this.props.userProfile.fullName && this.props.userProfile.fullName.toLowerCase() === 'hsg parent' ? 'Parent' : this.props.userProfile.fullName

                if (template && template.template) {
                    this.props.sendFirstDeclarationEmail(
                        template.template,
                        Constants.communicationMap.HELPERS.EMAIL_RECIPIENTS([{ name: userName, email: this.props.userProfile.inEmail }]),
                        Constants.communicationMap.HELPERS.EMAIL_VARIABLES({ name: userName, userName: this.props.userProfile.email })
                    )
                }
            }

            this.setState({ imageObjName: null, formSubmission: true, covidDeclarationCertify: false });
        } else if (!error) {
            this.setState({ imageObjName: null, showCovidDeclarationErrorResponse: true });
        }
    };

    handleBlur = (input) => {
        let x = input
    };

    // closeCovidDeclarationResponse () {
    //     this.setState({ showCovidDeclarationResponse: false })
    //     window.location.reload(false);
    // }

    // covidDeclarationResponse = () => (
    //     <HSGModalComponent
    //         show={this.state.showCovidDeclarationResponse || false}
    //         onClose={() => this.closeCovidDeclarationResponse()}
    //         onHide={() => this.closeCovidDeclarationResponse()}
    //         header="Thank you!"
    //         hideHead
    //         body={
    //             <div>
    //                 <p className="hsg-modal-body-message-normal">{STRING_COVID_DECLARATION_MODAL_MESSAGE}</p>

    //                 <div className="center margin-top-20">
    //                     {this.state.currentFormSubmission === TYPE_SUBMISSION_HIGH_RISK ? (
    //                         <p className="hsg-modal-body-message-error">
    //                             {STRING_COVID_DECLARATION_MODAL_STATUS_RISK}
    //                         </p>
    //                     ) : this.state.currentFormSubmission === TYPE_SUBMISSION_SUSPECTED ? (
    //                         <p className="hsg-modal-body-message-error">
    //                             {STRING_COVID_DECLARATION_MODAL_STATUS_SUSPECTED}
    //                         </p>
    //                     ) : (
    //                         <p className="hsg-modal-body-message-ok">{STRING_COVID_DECLARATION_MODAL_STATUS_NORMAL}</p>
    //                     )}
    //                 </div>
    //                 <div className="center margin-top-20">
    //                     <button
    //                         className=" margin-top-20 hsg-btn hsg-covid-declaration-btn-modified"
    //                         onClick={() => this.closeCovidDeclarationResponse()}
    //                     >
    //                         {" "}
    //                         OK{" "}
    //                     </button>
    //                 </div>
    //             </div>
    //         }
    //     />
    // );

    closeCovidDeclarationErrorResponse() {
        this.setState({ showCovidDeclarationErrorResponse: false });
        window.location.reload(false);
    }

    covidDeclarationErrorResponse = () => (
        <HSGModalComponent
            show={this.state.showCovidDeclarationErrorResponse || false}
            onClose={() => this.closeCovidDeclarationErrorResponse()}
            onHide={() => this.closeCovidDeclarationErrorResponse()}
            header="Thank you!"
            hideHead
            body={
                <div>
                    <p className="hsg-modal-body-message-normal">{STRING_COVID_DECLARATION_MODAL_MESSAGE_ERROR}</p>

                    <div className="center margin-top-20"></div>
                    <div className="center margin-top-20">
                        <button
                            className=" margin-top-20 hsg-btn hsg-covid-declaration-btn-modified"
                            onClick={() => this.closeCovidDeclarationErrorResponse()}
                        >
                            {STRING_COVID_DECLARATION_BUTTON_OK}
                        </button>
                    </div>
                </div>
            }
        />
    );

    covidDeclarationForm = (updatedMeta) => (
        <FormComponent
            key={FORM_DATA.key}
            // onClose={() => this.handlePreviousButton()}
            onSubmit={(data) => this.handleSubmit(data)}
            formDefs={{ ...FORM_DATA, metaData: updatedMeta }}
            onFieldBlur={(input) => this.handleBlur(input)}
        />
    );

    covidDeclarationResponse = () => (
        <div>
            <div className="col-xs-12 center">
                <div className="hsg-covid-declaration-form-response-root">
                    <div className="hsg-covid-declaration-form-response-head">
                        {STRING_COVID_DECLARATION_RESPONSE_HEAD}
                    </div>

                    <div className="hsg-covid-declaration-form-response-status">
                        {this.state.currentUserLatestDeclarationStatus === TYPE_MAP_SUBMISSION.NORMAL ? (
                            <div className="hsg-covid-declaration-form-response-status-normal">
                                {STRING_COVID_DECLARATION_MODAL_STATUS_NORMAL}
                            </div>
                        ) : this.state.currentUserLatestDeclarationStatus === TYPE_MAP_SUBMISSION.SUSPECTED ? (
                            <div className="hsg-covid-declaration-form-response-status-suspected">
                                {STRING_COVID_DECLARATION_MODAL_STATUS_SUSPECTED}
                            </div>
                        ) : this.state.currentUserLatestDeclarationStatus === TYPE_MAP_SUBMISSION.RISK ? (
                            <div className="hsg-covid-declaration-form-response-status-risk">
                                {STRING_COVID_DECLARATION_MODAL_STATUS_RISK}
                            </div>
                        ) : null}
                    </div>
                    <div className="hsg-covid-declaration-form-response-advise">
                        {this.state.currentUserLatestDeclarationStatus === TYPE_MAP_SUBMISSION.NORMAL ? STRING_COVID_DECLARATION_RESPONSE_ADVISE_NORMAL : STRING_COVID_DECLARATION_RESPONSE_ADVISE_RISK}
                    </div>
                    <div className="hsg-covid-declaration-form-response-content">
                        {STRING_COVID_DECLARATION_RESPONSE_CONTENT}
                    </div>
                    <div className="hsg-covid-declaration-form-response-options">
                        <div className="col-xs-12 col-sm-6 padding-0">
                            <button 
                                className="hsg-btn hsg-covid-declaration-form-response-btn-modified" 
                                onClick={()=>{this.props.changeLocation(ROUTE_MAP.MY_DECLARATION)}}
                            >
                                {STRING_COVID_DECLARATION_BUTTON_VIEW_RESPONSE}
                            </button>
                        </div>
                        <div 
                            className="col-xs-12 col-sm-6 padding-0"
                            onClick={()=>this.setState({currentActiveForm: FORM_TYPE.declaration})}
                        >
                            <button className="hsg-btn-white hsg-covid-declaration-form-response-transparent">
                                {STRING_COVID_DECLARATION_BUTTON_ANOTHER_RESPONSE}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );

    covidDeclarationGlobalStats = () => (
        <div>
                <div className="col-xs-12 padding-right-0">
                    <div className="col-xs-12 padding-0 hsg-dashboard-covid-declaration-global-stats-head">
                        {/* <div className="hsg-dashboard-card hsg-dashboard-covid-declaration-global-stats-content"> */}
                        <div className="hsg-dashboard-covid-declaration-global-stats-content">
                            <div className="hsg-dashboard-covid-declaration-global-stats-sub-content">
                                <span>
                                    {this.props.organization.stateName && this.props.organization.cityName ? `${this.props.organization.stateName} - ${this.props.organization.cityName}` : 'India'}
                                </span>
                                {/* <img style={{paddingLeft: 16, cursor: "pointer"}} src={iconLocation} onClick={()=>this.props.toggleUserProfileModal(true)} aria-hidden="true"></img> */}                                
                            </div>
                            <a
                                href={URL_COVID_DASHBOARD_REF}
                                target="_blank"
                                className="col-xs-6 padding-0 left hsg-dashboard-covid-declaration-global-stats-option"
                            >
                                {STRING_GLOBAL_STATS_VIEW_MORE}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-xs-12 padding-0 hsg-scroll-horizontal-scroll hsg-dashboard-covid-overall-numbers-group">
                    {COVID_DECLARATION_GLOBAL_STATS.map((element, index) => (
                        <div className={element.className} key={index}>
                            <div className="hsg-dashboard-covid-overall-numbers hsg-dashboard-card">
                                <div className="col-xs-8 left padding-0">
                                    <div className="hsg-dashboard-covid-overall-numbers-label">{element.label}</div>
                                    <div className="hsg-dashboard-covid-overall-numbers-value">
                                        {this.props.covidGlobalDashboard[element.key] ? Number(this.props.covidGlobalDashboard[element.key]).toLocaleString() : 'NA' }
                                    </div>
                                </div>
                                <div className="col-xs-4 center padding-0 hsg-dashboard-covid-overall-numbers-icon-group">
                                    <div
                                        className="hsg-dashboard-covid-overall-numbers-icon-frame center"
                                        style={element.iconBackground}
                                    >
                                        <img
                                            className="hsg-dashboard-covid-overall-numbers-icon"
                                            aria-hidden="true"
                                            src={element.icon}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
    )

    render() {
        const customFields = {
            // covidDeclarationFileUpload: () => this.covidDeclarationFileUpload(),
            covidDeclarationCertify: () => this.covidDeclarationCertify(),
        };

        const updatedMeta = FORM_DATA.metaData.map((dataItem) => {
            if (!!customFields[dataItem.type]) {
                const component = customFields[dataItem.type]();
                return {
                    name: dataItem.name,
                    type: "wildcard",
                    component,
                };
            } else {
                return dataItem;
            }
        });

        return (
            <div className="hsg-covid-declaration-root hsg-covid-declaration-back-image">
                <div className="container-fluid">
                    <div className="col-xs-12 padding-0" style={{minHeight: 530}}>
                        <div className="col-sm-6 hidden-xs">
                            <img className="hsg-covid-declaration-family-picture" src={groupPictureMain}></img>
                        </div>
                        <div 
                            className={`col-sm-6 col-xs-12 hsg-no-mobile-padding ${
                                this.state.currentActiveForm === FORM_TYPE.declaration ? "" : "center"
                            }`}
                        >
                            <div className="hsg-covid-declaration-form">
                                <div className="container-fluid">
                                    <div className="margin-bottom-20">
                                        <div
                                            className={`col-xs-12 hsg-covid-declaration-heading ${
                                                this.state.currentActiveForm === FORM_TYPE.declaration ? "" : "center"
                                            }`}
                                        >
                                            {STRING_COVID_DECLARATION_HEADING}
                                        </div>
                                    </div>
                                    <div>
                                        {this.state.currentActiveForm === FORM_TYPE.declaration
                                            ? this.covidDeclarationForm(updatedMeta)
                                            : this.covidDeclarationResponse()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-xs-12 padding-left-0 margin-top-50">{this.covidDeclarationGlobalStats()}</div> */}

                </div>

                {/* {this.covidDeclarationResponse()} */}
                {this.covidDeclarationErrorResponse()}
            </div>
        );
    }
}

export default CovidDeclaration;
